export default {
  // Add configuration overrides
  endpoints: {
    http: 'https://api.goodcity.hk'
  }
}
